import { httpClient, httpauditClient } from '../utils/http.client';
import { API_ENDPOINTS } from '../config/api.config';

export const auditService = {
  getAuditLogs: async (params) => {
    return await httpClient.get(API_ENDPOINTS.AUDIT.LIST, { params });
  },

  getAuditLogById: async (id) => {
    return await httpClient.get(`${API_ENDPOINTS.AUDIT.DETAIL}/${id}`);
  },

  getActionTypes: async () => {
    return await httpClient.get(API_ENDPOINTS.AUDIT.ACTION_TYPES);
  },

  getAuditSearch: async (params) => {
    return await httpauditClient.get(API_ENDPOINTS.AUDIT_SEARCH.AUDIT_SEARCH, { params });
  },

  exportAuditLogs: async (params) => {
    return await httpClient.get(API_ENDPOINTS.AUDIT.EXPORT, { 
      params,
      responseType: 'blob'
    });
  },
};
